import { render } from "./ListAvatarCard_v3.vue?vue&type=template&id=a8bd7b3a"
import script from "./ListAvatarCard_v3.vue?vue&type=script&lang=js"
export * from "./ListAvatarCard_v3.vue?vue&type=script&lang=js"

import "./ListAvatarCard_v3.vue?vue&type=style&index=0&id=a8bd7b3a&lang=scss"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__